import type { InputHTMLAttributes, ReactNode } from 'react'

type AuthFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string
  trailingAdornment?: ReactNode
}

export function AuthField({
  className = '',
  label,
  trailingAdornment,
  type = 'text',
  ...props
}: AuthFieldProps) {
  const inputClassName = [
    'min-h-[2.125rem] w-full rounded border bg-surface-card px-3 py-[0.4375rem]',
    'text-[0.8125rem] leading-6 text-text-primary placeholder:text-[#99a7b5]',
    'transition-[border-color,box-shadow] duration-150 focus-visible:outline-none',
    'border-border-soft focus-visible:border-brand-primary focus-visible:ring-4 focus-visible:ring-focus-ring',
    trailingAdornment ? 'pr-9' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <label className={`${className} flex w-full flex-col gap-2 text-left`}>
      <span className="text-[0.8125rem] leading-6 text-text-muted">{label}</span>
      <span className="relative flex items-center">
        <input className={inputClassName} type={type} {...props} />
        {trailingAdornment ? (
          <span className="absolute right-4 inline-flex items-center text-[#606975]" aria-hidden="true">
            {trailingAdornment}
          </span>
        ) : null}
      </span>
    </label>
  )
}
